/* RESPONSIBLE TEAM: team-phone */

export const PHONE_WORKER_PROTOCOL_VERSION = 1;

export interface HeartbeatConfig {
  appId: string;
  adminId: string;
  deviceSessionId: string;
  csrfToken: string;
}

export interface TabSummary {
  registered: number;
  visible: number;
  hidden: number;
  total: number;
}

export interface PhoneWorkerState {
  protocolVersion: number;
  connectedTabs: string[];
  heartbeatConfig: HeartbeatConfig | null;
  lastHeartbeatSuccess: number | null;
  consecutiveHeartbeatFailures: number;
  heartbeatHealthy: boolean;
}

export type TabToWorkerMessage =
  | {
      type: 'connect';
      tabId: string;
      sessionId: string;
      adminId: string;
      appId: string;
      role: 'tab' | 'observer';
    }
  | { type: 'disconnect'; tabId: string }
  | { type: 'shutdown' }
  | { type: 'heartbeat-config'; config: HeartbeatConfig }
  | { type: 'csrf-update'; csrfToken: string }
  | { type: 'device-state-update'; tabId: string; deviceState: string }
  | { type: 'visibility-changed'; tabId: string; visible: boolean; lastInteraction: number }
  | { type: 'request-state'; tabId: string };

export type WorkerToTabMessage =
  | { type: 'state-update'; state: PhoneWorkerState }
  | {
      type: 'heartbeat-status';
      healthy: boolean;
      lastSuccess: number | null;
      tabSummary: TabSummary;
    }
  | { type: 'error'; error: string; context: string };
